import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ContactModal from './ContactModal';

const ContactPage = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/', { replace: true });
  };

  // Handle direct URL access - always show the modal
  useEffect(() => {
    // Ensure modal is always displayed when on this route
  }, []);

  return (
    <ContactModal 
      isOpen={true} 
      onClose={handleClose} 
    />
  );
};

export default ContactPage;